import { get } from 'react-hook-form';

export const getValueFromFormState = (obj, path, defaultValue) =>
  get(obj, path, defaultValue);
